// Optional bootstrap to register built-in connectors at app start.
import { connectorRegistry } from './connector.registry';
import { tenableConnectorFactory } from './tenable.connector';
import { rapid7ConnectorFactory } from './rapid7.connector';

export function registerBuiltInConnectors() {
  connectorRegistry.register('tenable', tenableConnectorFactory);
  connectorRegistry.register('rapid7', rapid7ConnectorFactory);
  // Additional vendor connectors can be registered here.
}
